export default __webpack_public_path__ + "navigation-examples-route-lines-styling-thumbnail-960-f7c7bfb127a331e7aafd479c9e9af3e0.png";